import React, { useReducer } from 'react';
import ProvinciaContext from './provinciaContext';
import ProvinciaReducer from './provinciaReducer';

import clienteAxios from '../../service/axios';

import { 
    OBTENER_PROVINCIAS,
    AGREGAR_PROVINCIA,
    ELIMINAR_PROVINCIA,
    ACTUALIZAR_PROVINCIA,
    PROVINCIA_OK,
    PROVINCIA_ERROR,
    PROVINCIA_ACTUAL,
    OBTENER_PROVINCIA,
    LIMPIAR_PROVINCIA
} from 'types/context';

const ProvinciaState = props => {
    const initialState = {
        provincias : [],
        provincia: null,
        pais: null,
        formulario : false,
        errorformulario: false,        
        mensaje: null,
        pagina: 1,
        totalRegistros: 0
    }

    const [ state, dispatch ] = useReducer(ProvinciaReducer, initialState);

    // Obtener los provincias
    const obtenerProvincias = async (paisID,pagina=1,filasPorPag =70, query) => {
        let parametros = {pagina:pagina,tamanio:filasPorPag};
        if(query){
            parametros.nombre = query;
        }
        try {
            const resultado = await clienteAxios.get(`/provincias?pais=${paisID}`,{params:parametros});
            dispatch({
                type: OBTENER_PROVINCIAS,
                payload: resultado.data.provincias
            })
            return resultado.data.provincias
        } catch (error) {
            const alerta = {
                msg: error.response.data.message,
                categoria: 'error'
            }            
            dispatch({
                type: PROVINCIA_ERROR,
                payload: alerta
            })
        }
    }
    // Agregar nueva provincia
    const agregarProvincia = async provincia => {

        try {
            const resultado = await clienteAxios.post('/provincias', provincia);
            //console.log(resultado);
            // Insertar la prov en el state
            dispatch({
                type: AGREGAR_PROVINCIA,
                payload: resultado.data.provincia
            })
            const alerta = {
                msg: "Provincia creada con exito",
                categoria: 'exito'
            }
            dispatch({
                type: PROVINCIA_OK,
                payload: alerta
            })
        } catch (error) {
            const alerta = {
                msg: error.response.data.message,
                categoria: 'error'
            }
            
            dispatch({
                type: PROVINCIA_ERROR,
                payload: alerta
            })
        }
    }
    // Selecciona la Provincia que el usuario dio click
    const provinciaActual = provinciaId => {
        dispatch({
            type: PROVINCIA_ACTUAL,
            payload: provinciaId
        })
    }

    // Elimina una Provincia
    const eliminarProvincia = async provinciaId => {
        try {
            await clienteAxios.delete(`/provincias/${provinciaId}`);
            dispatch({
                type: ELIMINAR_PROVINCIA,
                payload: provinciaId
            })
            const alerta = {
                msg: "Provincia eliminada con exito",
                categoria: 'exito'
            }
            dispatch({
                type: PROVINCIA_OK,
                payload: alerta
            })
        } catch (error) {
            const alerta = {
                msg: error.response.data.message,
                categoria: 'error'
            }
            
            dispatch({
                type: PROVINCIA_ERROR,
                payload: alerta
            })
        }
    }

    // Aactualizar provincia
    const actualizarProvincia = async provincia => {

        try {
            const resultado = await  clienteAxios.put(`/provincias/${provincia.id}`, provincia);
            //console.log(resultado);
            // Actualizo la prov en el state
            dispatch({
                type: ACTUALIZAR_PROVINCIA,
                payload: resultado.data.provincia
            })
            const alerta = {
                msg: "Provincia actualizada con exito",
                categoria: 'exito'
            }
            dispatch({
                type: PROVINCIA_OK,
                payload: alerta
            })
        } catch (error) {
            const alerta = {
                msg: error.response.data.message,
                categoria: 'error'
            }
            
            dispatch({
                type: PROVINCIA_ERROR,
                payload: alerta
            })
        }
    }

    // muestra un error de validacion
    const errorProvincia = (msj,categoria) => {
        const alerta = {
            msg: msj,
            categoria: categoria
        }            
        dispatch({
            type: PROVINCIA_ERROR,
            payload: alerta
        })
    }

    // Obtener una provincia por su id
    const obtenerProvincia = async (provinciaID) => {
        try {
            const resultado =await clienteAxios.get(`/provincias?id=${provinciaID}`);
           
            //console.log(resultado);
            dispatch({
                type: OBTENER_PROVINCIA,
                payload: resultado.data
            })
            return resultado.data.provincias.rows;
        } catch (error) {
            const alerta = {
                msg: error.response.data.message,
                categoria: 'error'
            }            
            dispatch({
                type: PROVINCIA_ERROR,
                payload: alerta
            })
        }
    }
    const OkProvincia = (msj,categoria) => {
        const alerta = {
            msg: msj,
            categoria: categoria
        }            
        dispatch({
            type: PROVINCIA_OK,
            payload: alerta
        })
    }
    const clearErrorProvincia = () => {
        dispatch({
            type: PROVINCIA_ERROR,
            payload: null,
        });
        };

    const clearOkProvincia = () => {
        dispatch({
            type: PROVINCIA_OK,
            payload: null,
        });
    }
    const limpiarProvincia = () =>{
        dispatch({
            type: LIMPIAR_PROVINCIA,
            payload: null
        })
    }
    return(
        <ProvinciaContext.Provider
            value={{
                provincias: state.provincias,
                provincia: state.provincia,
                pais: state.pais,
                formulario: state.formulario,
                errorformulario: state.errorformulario,                
                mensaje: state.mensaje,
                obtenerProvincias,
                agregarProvincia,
                provinciaActual,
                eliminarProvincia,
                actualizarProvincia,
                errorProvincia,
                obtenerProvincia,
                clearOkProvincia,
                clearErrorProvincia,
                OkProvincia,
                limpiarProvincia
            }}
        >{props.children}

        </ProvinciaContext.Provider>
    )
}
export default ProvinciaState;
